import React from 'react';
import {useAppStore} from "../../../GlobalStore/GlobalStore.ts";
import {isMobileApp} from "../../../Utils/misc/envNameUtils.ts";

interface UpdateUIProps {}

const UpdateUI: React.FC<UpdateUIProps> = () => {
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;

    const handleUpdate = () => {
        if (environment.includes("jetbrains")) {
            window.jetbrainsPostMessage(JSON.stringify({
                functionName: "resetWebview",
                data: []
            }));
        }
        else if (isMobileApp(environment)) {
            // Need a mobile app handler to pick this up
            window.ReactNativeWebView.postMessage(JSON.stringify({
                functionName: "resetWebview",
                data: []
            }));
        }
        else if (environment === "chrome") {
            // Need a chrome handler to pick this up
            window.parent.postMessage({
                functionName: "resetWebview",
                data: []
            }, '*');
        }
        else if (environment.includes("web")) {
            window.location.reload();
        }
    };

    return (
        <div className="fixed inset-0 bg-neutral-100/95 dark:bg-neutral-900/95 flex items-center justify-center p-4 z-50">
            <div className="bg-neutral-300 dark:bg-neutral-800/80 rounded-xl shadow-2xl w-[98%] sm:w-11/12 max-w-md overflow-hidden border border-neutral-700/50">
                <div className="p-6">
                    <div className="mb-6">
                        <h2 className="text-xl font-semibold dark:text-white mb-2 text-center">Update Required</h2>
                        <p className="text-lg dark:text-neutral-300 text-center">A new version of the UI is available. You must update to continue using the application.</p>
                    </div>
                    <div className="flex justify-center">
                        <button
                            onClick={handleUpdate}
                            className="px-6 py-2 rounded-lg bg-cyan-600 hover:bg-cyan-700 transition-colors duration-200 text-white"
                        >
                            Update Now
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateUI;